import TargetManagerColumn from './TargetManagerColumn';

export default TargetManagerColumn;
